import { render, staticRenderFns } from "./ReadIdCard.vue?vue&type=template&id=21a5f0a2&scoped=true&"
import script from "./ReadIdCard.vue?vue&type=script&lang=js&"
export * from "./ReadIdCard.vue?vue&type=script&lang=js&"
import style0 from "./ReadIdCard.vue?vue&type=style&index=0&id=21a5f0a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5f0a2",
  null
  
)

export default component.exports